<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import MmIcon from '../base/MmIcon.vue'
import ShellStudioMenu from './ShellStudioMenu.vue'
import { primaryLinks, isShellRouteActive } from './navigation'
const { t } = useI18n()
const route = useRoute()
</script>

<template>
  <nav class="tabbar mm-root" :aria-label="t('mm.shell.primary')">
    <template v-for="link in primaryLinks" :key="link.to">
      <ShellStudioMenu v-if="link.to === '/create'" mobile />
      <NuxtLink v-else :to="link.to" :aria-current="isShellRouteActive(route.path, link.to) ? 'page' : undefined"><MmIcon :name="link.icon" :size="22" /><span>{{ t(link.key) }}</span></NuxtLink>
    </template>
    <NuxtLink to="/me" :aria-current="route.path === '/me' ? 'page' : undefined"><MmIcon name="user" :size="22" /><span>{{ t('mm.shell.me') }}</span></NuxtLink>
  </nav>
</template>
